module.exports = __webpack_public_path__ + "static/img/ico_logo.bdbcfc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/application_intro/ico_logo.png
// module id = 8Z6I
// module chunks = 0